import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import { SvgIcon, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  '@keyframes sparkle': {
    '0%': {
      transform: 'scale(1)',
      opacity: 1
    },
    '66%': {
      transform: 'scale(0.56875)',
      opacity: 0.5
    },
    '100%': {
      transform: 'scale(1)',
      opacity: 1
    }
  },
  root: {
    color: theme.palette.Dela.icon,
    fontSize: theme.spacing(3),
    margin: theme.spacing(-0.375),
    '& #s1': {
      animation: '$sparkle 1.2s ease-in-out 0s infinite',
      transformOrigin: '6.907px 6.907px'
    },
    '& #s2': {
      animation: '$sparkle 1.2s ease-in-out 0.6s infinite',
      transformOrigin: '14.1875px 14.1875px'
    }
  }
}));

const DelaStarCalculatingIcon = React.forwardRef(
  ({ className, includeTitleAccess = true, ...rest }, ref) => {
    const intl = useIntl();
    const classes = useStyles();

    return (
      <SvgIcon
        {...rest}
        className={classNames(classes.root, className)}
        titleAccess={
          includeTitleAccess
            ? intl.formatMessage({
                id: 'dela.suggestedByDelaAICalculating'
              })
            : undefined
        }
        ref={ref}
      >
        <path
          id="s1"
          d="m6.907 2.907c0.1786 0 0.3356 0.1184 0.3846 0.2901l0.4337 1.518c0.1898 0.6644 0.7092 1.184 1.374 1.374l1.518 0.4337c0.1717 0.04907 0.2901 0.206 0.2901 0.3846s-0.1184 0.3356-0.2901 0.3846l-1.518 0.4337c-0.6644 0.1898-1.184 0.7092-1.374 1.374l-0.4337 1.518c-0.04906 0.1717-0.206 0.29-0.3846 0.29s-0.3355-0.1184-0.3846-0.29l-0.4337-1.518c-0.1898-0.6644-0.7092-1.184-1.374-1.374l-1.518-0.4337c-0.1717-0.04906-0.2901-0.206-0.2901-0.3846s0.1184-0.3355 0.2901-0.3846l1.518-0.4337c0.6644-0.1898 1.184-0.7092 1.374-1.374l0.4337-1.518c0.04907-0.1717 0.206-0.2901 0.3846-0.2901z"
        />
        <path
          id="s2"
          d="m14.19 7.275c0.3086 0 0.5799 0.2046 0.6646 0.5013l0.7494 2.623c0.328 1.148 1.225 2.046 2.374 2.374l2.623 0.7494c0.2967 0.08479 0.5013 0.356 0.5013 0.6646s-0.2046 0.5799-0.5013 0.6646l-2.623 0.7494c-1.148 0.328-2.046 1.225-2.374 2.374l-0.7494 2.623c-0.08478 0.2967-0.356 0.5011-0.6646 0.5011s-0.5797-0.2046-0.6646-0.5011l-0.7494-2.623c-0.328-1.148-1.225-2.046-2.374-2.374l-2.623-0.7494c-0.2967-0.08478-0.5013-0.356-0.5013-0.6646s0.2046-0.5797 0.5013-0.6646l2.623-0.7494c1.148-0.328 2.046-1.225 2.374-2.374l0.7494-2.623c0.08479-0.2967 0.356-0.5013 0.6646-0.5013z"
        />
      </SvgIcon>
    );
  }
);

DelaStarCalculatingIcon.propTypes = {
  className: PropTypes.string,
  includeTitleAccess: PropTypes.bool
};

export default DelaStarCalculatingIcon;
